export default __webpack_public_path__ + "static/media/ttMobile.38f24478.png";